"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLion = _interopRequireDefault(require("@rosetta/react-lion"));

var _variables = _interopRequireDefault(require("../constants/variables"));

var _mixins = require("../constants/mixins");

var _reduxUtils = require("@rosetta/redux-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContainerLabel = _styled["default"].div(function (props) {
  var styles = {
    display: "flex",
    cursor: "pointer",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    margin: 5
  };

  if (props.disabledCheckbox) {
    styles.opacity = "0.5";
    styles.cursor = "default";
  }

  return styles;
});

var CheckboxLabelSpan = _styled["default"].label(function (props) {
  var styles = _objectSpread({
    color: (0, _reduxUtils.extractPath)(props, "theme.modalCheckboxLabelSpan") || _variables["default"].black,
    paddingLeft: 5,
    cursor: props.disabled ? "default" : "pointer"
  }, _mixins.noSelectMixin);

  if (!props.disabled) {
    styles["&:hover"] = {
      color: (0, _reduxUtils.extractPath)(props, "theme.modalCheckboxLabelSpanHover") || _variables["default"].grey
    };
  }

  return styles;
});
/* Hide the browser's default checkbox */


var CheckboxInput = _styled["default"].input(function (props) {
  var styles = {
    position: "absolute",
    opacity: 0,
    height: 20,
    width: 20,
    cursor: props.disabled ? "default" : "pointer",
    zIndex: 20000
  };
  return styles;
});
/* Create a custom checkbox */


var CustomCheckmark = _styled["default"].div(function (props) {
  /* Style the checkmark/indicator on the :after Psuedo-Selector  */
  var afterPsuedoSelector = {
    left: 13,
    top: 2,
    width: 5,
    height: 10,
    marginTop: 2,
    marginLeft: 7,
    border: "solid ".concat(_variables["default"].white),
    borderWidth: " 0 3px 3px 0",
    transform: "rotate(45deg)",
    // ::after psuedo hidden when not checked
    content: "''",
    display: "none"
  };
  /* Show the checkmark when checked */

  if (props.inputIsChecked) {
    afterPsuedoSelector.display = "block";
  }

  var styles = {
    order: "-1",
    top: 10,
    left: 11,
    height: 20,
    width: 20,
    backgroundColor: "#ccc",
    transition: "background 0.25s linear",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderRadius: "25%",
    "&::after": afterPsuedoSelector
  };
  /* When the checkbox is checked, add a blue background */

  if (props.inputIsChecked) {
    styles.backgroundColor = "#a8d173";
  }
  /* On mouse-over, add a grey background color */


  if (!props.inputIsChecked && props.containerLabelIsHovered) {
    styles.backgroundColor = "#dcdcdc";
  }

  return styles;
});

var ModalCheckbox = /*#__PURE__*/function (_PureComponent) {
  _inherits(ModalCheckbox, _PureComponent);

  var _super = _createSuper(ModalCheckbox);

  function ModalCheckbox() {
    var _this;

    _classCallCheck(this, ModalCheckbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      checked: _this.props.checked || "",
      disabled: _this.props.disabled || "",
      isHovered: false
    });

    _defineProperty(_assertThisInitialized(_this), "onHoverCheckbox", function () {
      return _this.setState({
        isHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onHoverCheckboxOff", function () {
      return _this.setState({
        isHovered: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.checked !== _this.props.checked) {
        _this.setState({
          checked: _this.props.checked
        });
      }

      if (prevProps.disabled !== _this.props.disabled) {
        _this.setState({
          disabled: _this.props.disabled
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderLabel", function (key, text) {
      if (key) {
        return /*#__PURE__*/_react["default"].createElement(_reactLion["default"].span, {
          lionkey: key
        });
      } else if (text) {
        return /*#__PURE__*/_react["default"].createElement("span", null, text);
      } else {
        return;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (event) {
      if (_this.state.disabled) return;

      _this.props.onChange(event);
    });

    return _this;
  }

  _createClass(ModalCheckbox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement(ContainerLabel, {
        key: "".concat(this.props.dataKey, "_").concat(this.props.value),
        htmlFor: this.props.dataKey,
        "data-qa": "".concat(this.props.dataKey, "-").concat(this.state.checked || "false"),
        disabledCheckbox: this.state.disabled // hover listeners
        ,
        onMouseOver: function onMouseOver() {
          return _this2.onHoverCheckbox();
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.onHoverCheckboxOff();
        },
        onMouseOut: function onMouseOut() {
          return _this2.onHoverCheckboxOff();
        }
      }, /*#__PURE__*/_react["default"].createElement(CheckboxLabelSpan, {
        disabled: this.state.disabled === true,
        htmlFor: this.props.dataKey,
        "data-qa": this.props.dataKey
      }, this.renderLabel(this.props.labelKey, this.props.labelText)), /*#__PURE__*/_react["default"].createElement(CheckboxInput, {
        type: "checkbox",
        name: this.props.dataKey,
        id: this.props.dataKey,
        checked: this.state.checked,
        disabled: this.state.disabled,
        onChange: this.handleOnChange,
        style: {
          margin: 0,
          "float": "none"
        }
      }), /*#__PURE__*/_react["default"].createElement(CustomCheckmark, {
        inputIsChecked: this.state.checked,
        containerLabelIsHovered: this.state.isHovered
      }));
    }
  }]);

  return ModalCheckbox;
}(_react.PureComponent);

ModalCheckbox.propTypes = {
  checked: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  dataKey: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  labelKey: _propTypes["default"].string,
  labelText: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].string
};
var _default = ModalCheckbox;
exports["default"] = _default;